import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "./App.css";
import Main from "./components/Main";
import UserDetailsManager from "./components/UserDetailsManager";
import { createContext, useEffect, useState } from "react";
import useGetClinicIdsList from "./global-state-hooks/useGetClinicIdsList";
import useClinicId from "hooks/useClinicId";
import useGetClinicCode from "global-state-hooks/useGetClinicCode";
import { useTheme } from "hooks/useTheme";
import config from "config/config";

const twentyFourHoursInMs = 1000 * 60 * 60 * 24;
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: twentyFourHoursInMs,
    },
  },
});
export const GlobalContext = createContext();

const App = () => {
  const clinicIdList = useGetClinicIdsList();
  const clinicCode = useGetClinicCode();
  const [clinicId, selectClinic] = useClinicId(clinicIdList, clinicCode);

  const [data, setData] = useState(() => {
    try {
      const cached = localStorage.getItem("df-chat-theme");
      return cached ? JSON.parse(cached) : undefined;
    } catch (err) {
      return undefined;
    }
  });

  const fetchChatWidgetTheme = async () => {
    if (!clinicId) return;

    try {
      const res = await fetch(
        `${config.BASE_URL}/api/v1/chat_widget_themes/${clinicId}`
      );
      const json = await res.json();
      const themeData = json.data?.[0]?.theme_data;

      setData(themeData);
      localStorage.setItem("df-chat-theme", JSON.stringify(themeData));
    } catch (err) {
      console.error("Failed to fetch chat widget theme", err);
    }
  };

  useEffect(() => {
    fetchChatWidgetTheme();
  }, [clinicId]);

  return (
    clinicIdList.length > 0 && (
      <QueryClientProvider client={queryClient}>
        <GlobalContext.Provider
          value={{ clinicIdList, clinicId, selectClinic, theme: data }}
        >
          <UserDetailsManager>
            <Main />
          </UserDetailsManager>
        </GlobalContext.Provider>
      </QueryClientProvider>
    )
  );
};

export default App;
